import { Button } from "@/components/ui/button";
import { Check, Sparkles } from "lucide-react";
import AIAssistantPreview from "@/components/AIAssistantPreview";

const heroFeatures = [
  "Facturas procesadas en 30 segundos con OCR e IA",
  "Asesor fiscal con 48 artículos reales del BOE",
  "VeriFactu AEAT y Modelos 130/303 automáticos",
];

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative overflow-hidden bg-taxby-hero pt-24 pb-20 md:pt-28 md:pb-28"
    >
      <div className="hero-mesh pointer-events-none absolute inset-0 opacity-40" aria-hidden />
      <div
        className="pointer-events-none absolute -right-16 top-10 h-72 w-72 rounded-full bg-white/10 blur-3xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute left-1/4 top-1/2 h-96 w-96 -translate-y-1/2 rounded-full bg-taxby-purple/20 blur-3xl"
        aria-hidden
      />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-14">
          <div>
            <div className="mb-6 flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs font-medium text-white backdrop-blur-sm">
                <Sparkles className="h-3.5 w-3.5 text-amber-200" />
                Asesoría fiscal + Inteligencia Artificial
              </span>
              <span className="rounded-full border border-emerald-400/30 bg-emerald-500/15 px-3 py-1 text-xs font-medium text-emerald-100">
                Entrenado con normativa española
              </span>
            </div>

            <h1 className="mb-6 text-left text-3xl font-bold leading-[1.15] tracking-tight text-white md:text-5xl lg:text-[3.35rem]">
              Tu gestoría fiscal con{" "}
              <span className="bg-gradient-to-r from-white via-purple-100 to-violet-200 bg-clip-text text-transparent">
                IA
              </span>
              , sin complicaciones
            </h1>

            <p className="mb-8 max-w-xl text-left text-base leading-relaxed text-white/85 md:text-lg">
              No es solo software contable: es un{" "}
              <strong className="font-semibold text-white">asesor fiscal inteligente</strong> que
              clasifica, explica y presenta por ti — con gestores humanos cuando lo necesitas.
            </p>

            <ul className="mb-8 space-y-3.5">
              {heroFeatures.map((feature) => (
                <li key={feature} className="flex items-start gap-3 text-left">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-white/35 bg-white/10">
                    <Check className="h-3.5 w-3.5 text-white" strokeWidth={2.5} />
                  </span>
                  <span className="text-sm text-white/95 md:text-base">{feature}</span>
                </li>
              ))}
            </ul>

            <div className="mb-8 flex items-center gap-3">
              <div className="flex -space-x-2">
                {["A", "M", "C"].map((initial) => (
                  <span
                    key={initial}
                    className="flex h-9 w-9 items-center justify-center rounded-full border-2 border-white/25 bg-white/15 text-sm font-semibold text-white backdrop-blur-sm"
                  >
                    {initial}
                  </span>
                ))}
              </div>
              <p className="max-w-xs text-left text-sm text-white/80">
                Autónomos que ya delegan la fiscalidad a la IA (con respaldo profesional)
              </p>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <Button
                onClick={() =>
                  document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" })
                }
                size="lg"
                className="rounded-full bg-white px-8 font-semibold text-taxby-violet shadow-lg shadow-black/20 hover:bg-white/95"
              >
                Probar el asesor IA
              </Button>
              <Button
                onClick={() =>
                  document.getElementById("ai")?.scrollIntoView({ behavior: "smooth" })
                }
                variant="outline"
                size="lg"
                className="rounded-full border-white/50 bg-white/5 font-semibold text-white hover:bg-white/15 hover:text-white"
              >
                Ver cómo funciona
              </Button>
            </div>
          </div>

          <div className="relative lg:pl-4">
            <AIAssistantPreview />
          </div>
        </div>
      </div>

      <div className="pointer-events-none absolute bottom-0 left-0 right-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 80"
          className="w-full"
          preserveAspectRatio="none"
        >
          <path
            fill="#ffffff"
            d="M0,48L60,42.7C120,37,240,27,360,26.7C480,27,600,37,720,42.7C840,48,960,48,1080,42.7C1200,37,1320,27,1380,22.3L1440,18L1440,80L0,80Z"
          />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
